import React, { useState } from "react";
import Preloader from "../../helper/Preloader";
import ColorInit from "../../helper/ColorInit";
import HeaderOne from "../../components/layout/HeaderOne";
import Breadcrumb from "../../components/Breadcrumb";
import FooterOne from "../../components/layout/FooterOne";
import BottomFooter from "../../components/layout/BottomFooter";
import Checkout from "../../components/account/Checkout";
import SelectAddress from "../../components/SelectAddress";
import ScrollToTop from "react-scroll-to-top";
import AddNewAddress from "../../components/AddNewAddress";

const CheckoutPage = () => {
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [addressId, setAddressId] = useState(null);
  const [addressEnum, setAddressEnum] = React.useState(0);

  const handleAddressEnumChange = (add) => {
    setAddressEnum(add);
  };

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={false} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#990A02" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderOne />

      {/* Breadcrumb */}
      <Breadcrumb
        title={
          addressEnum === 0
            ? "Checkout"
            : addressEnum === 1
            ? "Select Address"
            : "Add New Address"
        }
        isSelectAddress={addressEnum === 1}
        addressEnumChange={handleAddressEnumChange}
        isChildren={addressEnum !== 0}
      />

      {/* Checkout */}
      {addressEnum === 0 ? (
        <Checkout addressEnumChange={handleAddressEnumChange} selectedAddress={selectedAddress} onSelectAddress={setSelectedAddress} />
      ) : addressEnum === 1 ? (
        <SelectAddress
          addressEnumChange={handleAddressEnumChange}
          onEdit={(addressId) => {
            setAddressId(addressId);
            handleAddressEnumChange(2);
          }}
          selectedAddress={selectedAddress}
          onSelectAddress={(address) => {
            setSelectedAddress(address);
            handleAddressEnumChange(0);
          }}
        />
      ) : (
        <AddNewAddress
          addressId={addressId}
          onFinish={() => {
            handleAddressEnumChange(1);
            setAddressId(null);
            setSelectedAddress(null);
          }}
        />
      )}
      {/* <Checkout /> */}

      {/* ShippingOne */}
      {/* <ShippingOne /> */}

      {/* FooterTwo */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default CheckoutPage;
